import { render, staticRenderFns } from "./NotasPendentes.vue?vue&type=template&id=30121115"
import script from "./NotasPendentes.vue?vue&type=script&lang=js"
export * from "./NotasPendentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports